import { StateComponent } from "~/ecs/base"

export class AlwaysOnStage extends StateComponent {}
